module.exports = __webpack_public_path__ + "img/ic_twitter_bg_black.c092c465.svg";